/* eslint-disable compat/compat */
export default function parseFloatPolyfill() {
  if (Number.parseFloat === undefined) {
    Number.parseFloat = parseFloat
  }
}
